// src/components/Avertissement.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaInfoCircle } from 'react-icons/fa';

const Avertissement = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-3 bg-gray-50">
      <div className="container mx-auto max-w-3xl px-4">
        <div className="bg-primary/5 border-l-2 border-r-2 border-primary/30 p-2.5 rounded-md flex items-center justify-center shadow-sm">
          <FaInfoCircle className="text-primary/70 text-sm flex-shrink-0 mr-2" />
          <p className="text-gray-600 text-xs font-light">
            {t('avertissement.text')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Avertissement;
